import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { ApiVisa } from 'blg-akaun-ts-lib';
import { PermissionStates } from '../../modules/permission/permission-controller/root';
import { UserPermInquirySelectors } from '../../modules/permission/user-permissions-inquiry-controller/selectors';
import { SessionActions } from '../../modules/session/session-controller/actions';
import { SessionSelectors } from '../../modules/session/session-controller/selectors';
import { SessionStates } from '../../modules/session/session-controller/states';
import { DropDownService } from '../../services/drop-down-service';
import { ReplaySubject, Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-select-multi-location-drop-down',
  templateUrl: './select-multi-location-drop-down.component.html',
  styleUrls: ['./select-multi-location-drop-down.component.css']
})
export class SelectMultiLocationDropDownComponent implements OnInit, OnDestroy {

  @Input() location: FormControl;
  @Input() apiVisa: ApiVisa;
  @Input() selectedGuid: string;
  @Input() label = 'Location';
  @Input() options: any;
  @Input() readPermissionDefintion;
  @Input() companyGuid: string = '';
  @Input() customColumns: [];

  @Output() locationSelected = new EventEmitter<any>();

  userPermissionTarget$ = this.permissionStore.select(
    UserPermInquirySelectors.selectUserPermInquiry
  );

  serverSideFiltering = new FormControl();
  filteredOptions$: ReplaySubject<any[]> = new ReplaySubject<any[]>(1);
  selectedRow: any;
  rowData: any = [];
  key = "location";
  allSelected = false;
  filteredCache: any = [];
  locTargets: string[];

  /** flags to set the toggle all checkbox state */
  isIndeterminate = false;
  isChecked = false;

  protected _onDestroy = new Subject<void>();

  constructor(private dropDownService: DropDownService,
    private readonly store: Store<SessionStates>,
    private readonly permissionStore: Store<PermissionStates>
  ) { }

  ngOnInit() {
    // set initial selection
    this.locTargets = SharedUtilitiesHelperFunctions.getTargetsByPermission(this.userPermissionTarget$,
      this.readPermissionDefintion, 'bl_inv_mst_location'
    );

    this.store.select(SessionSelectors.selectDropDownRowData).subscribe(resolved => {
      this.rowData = resolved?resolved[this.key]?resolved[this.key]:[]:[];
      if (this.rowData.length === 0) {
        this.getRowData();
      }
      else {
        if(this.locTargets?.length>0){
          this.rowData = this.rowData.filter(record=>this.locTargets.includes(record.guid))
        }
        this.filteredOptions$.next(this.rowData.slice());
      }
    })

    // listen for search field value changes
    this.serverSideFiltering.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filtering();
      });
  }

  ngOnChanges() {
    console.log('ngOnChanges');
    if (this.isFilterCompany()) {
      this.getRowData();
    }
  }

  getRowData() {
    if (this.isFilterCompany() && !this.companyGuid) return;
    console.log('this.isFilterCompany', this.isFilterCompany());
    console.log('this.companyGuid', this.companyGuid);

    let formData = {
      "limit" : null,
      "orderBy" : "code",
      "order" : "ASC"
    }

    if (this.customColumns && this.customColumns.length > 0) {
      formData['customColumns'] = this.customColumns;
    }
    
    if (this.companyGuid) {
      Object.assign(formData,
        {
          "filterConditions": [
          {
            "filterColumn": "guid_bl_fi_mst_comp",
            "filterValues": [this.companyGuid],
            "filterOperator": "="
          }]
        }
      )
    }

    this.dropDownService.get('location', formData, this.apiVisa).subscribe(resolved => {
      this.rowData = resolved.data;
      //console.log('locTargets', this.locTargets);
      if (!this.isFilterCompany()) {
        this.store.dispatch(SessionActions.selectDropDownRowData({key: this.key, rowData: this.rowData}));
      }
      if(this.locTargets?.length>0){
        this.rowData = this.rowData.filter(record=>this.locTargets.includes(record.guid))
      }
      //fill the drop down
      this.filteredOptions$.next(this.rowData.slice());

      // set default location
      this.store.select(SessionSelectors.selectPersonalSettings).subscribe({next: (resolve: any) => {
        if (resolve?.DEFAULT_LOCATION) {
          if (this.isMultiple()) {
            this.location.patchValue([resolve?.DEFAULT_LOCATION]);
          }
          else {
            this.location.patchValue(resolve?.DEFAULT_LOCATION);
          }
        }
      }});
    });
  }

  filtering() {
    if (!this.rowData) {
      return;
    }
    // get the search keyword
    let search = this.serverSideFiltering.value;
    if (!search) {
      this.filteredOptions$.next(this.rowData.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter
    this.filteredOptions$.next(
      this.rowData.filter((option) =>
        (option.code ?
          option.code.toLowerCase().indexOf(search) > -1 : null) ||
        (option.name ?
          option.name.toLowerCase().indexOf(search) > -1 : null))
    );
  }

  // onSelect(guid: string) {
  //   if (guid) {
  //     this.location.patchValue(guid);
  //     this.selectedRow = this.rowData.find(row => row.guid === guid);
  //     this.locationSelected.emit(this.selectedRow);
  //   }
  // }

  onSelect(selected: any[]) {
    if (selected && selected.length > 0) {
      this.location.patchValue(selected);
      this.selectedRow = this.rowData.filter(row => selected.includes(row.guid));
      this.locationSelected.emit(this.selectedRow);
    }
  }

  isRequired() {
    let value = this.options['required'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isMultiple() {
    let value = this.options['multiple'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  isFilterCompany() {
    let value = this.options['filterCompany'];
    if (value === true || value === false) {
      return value;
    }
    else if (value) {
      return value.includes(true);
    }
    return false;
  }

  toggleSelectAll(selectAllValue: boolean) {
    this.filteredOptions$.pipe(take(1), takeUntil(this._onDestroy))
      .subscribe(val => {
        if (selectAllValue) {
          this.location.patchValue([...val.map(item => item.guid)]);
          //this.location.patchValue(val);
        } else {
          this.location.patchValue([]);
        }
      });
  }

  setToggleAllCheckboxState() {
    if (!this.isMultiple()) return;
    let filteredLength = 0;
    if (this.location && this.location.value) {
      this.filteredCache.forEach(el => {
        if (this.location.value.indexOf(el) > -1) {
          filteredLength++;
        }
      });
      this.isIndeterminate = filteredLength > 0 && filteredLength < this.filteredCache.length;
      this.isChecked = filteredLength > 0 && filteredLength === this.filteredCache.length;
    }
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

}
